import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErrorManagementComponent } from "./containers/error-management/error-management.component";
import { ModalWrapperModule } from "@shared/components/modal-wrapper/modal-wrapper.module";
import { ErrorListFiltersComponent } from "./components/error-list-filters/error-list-filters.component";
import { ErrorListComponent } from "./components/error-list/error-list.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacyTableModule as MatTableModule } from "@angular/material/legacy-table";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { InputAutocompleteModule } from "@shared/components/input-autocomplete/input-autocomplete.module";
import { InputSelectModule } from "@shared/components/input-select/input-select.module";
import { PaginationModule } from "@shared/components/pagination/pagination.module";
import { TooltipModule } from "@shared/components/tooltip/tooltip.module";
import { SharedModule } from "../../shared/shared.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { EntityDataService, EntityDefinitionService, EntityMetadataMap } from "@ngrx/data";
import { ErrorManagementEntityService } from "./services/error-management-entity.service";
import { ErrorManagementResolver } from "./services/error-management.resolver";
import { ErrorManagementDataService } from "./services/error-management-data.service";
import { ErrorManagementRoutingModule } from "./error-management-routing.module";
import { ErrorTypesModule } from "./error-types/error-types.module";
import { OutputMessageDialogComponent } from "./components/output-message-dialog/output-message-dialog.component";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";

const entityMetadata: EntityMetadataMap = {
	ErrorManagement: {
		entityDispatcherOptions: {}
	}
};

@NgModule({
	declarations: [
		ErrorManagementComponent,
		ErrorListFiltersComponent,
		ErrorListComponent,
		OutputMessageDialogComponent
	],
	imports: [
		CommonModule,
		ErrorManagementRoutingModule,
		ModalWrapperModule,
		InputWrapperModule,
		MatInputModule,
		MatFormFieldModule,
		FormsModule,
		ReactiveFormsModule,
		InputSelectModule,
		InputAutocompleteModule,
		MatButtonModule,
		MatTableModule,
		PaginationModule,
		MatPaginatorModule,
		MatTooltipModule,
		PipesModule,
		SharedModule,
		TooltipModule,
		MatSelectModule,
		ErrorTypesModule,
		MatDialogModule,
		BreadcrumbsModule
	],

	providers: [ErrorManagementEntityService, ErrorManagementResolver, ErrorManagementDataService]
})
export class ErrorManagementModule {
	constructor(
		eds: EntityDefinitionService,
		private entityDataService: EntityDataService,
		private errorManagementDataService: ErrorManagementDataService
	) {
		eds.registerMetadataMap(entityMetadata);
		entityDataService.registerService("ErrorManagement", errorManagementDataService);
	}
}
